import * as React from 'react';
import { ExpenseListData } from '../types';

type Props = {
  data: ExpenseListData;
};

const ExpenseListWidget: React.FC<Props> = ({ data }) => {
  if (data.items.length === 0) {
    return null;
  }
  return (
    <div className="ai-chat-widget ai-chat-widget-expense-list">
      {data.items.map((item, idx) => (
        <div key={idx} className="ai-chat-widget-expense-list-row">
          <div className="ai-chat-widget-expense-list-main">
            <span className="ai-chat-widget-expense-list-desc">
              {item.description || '—'}
            </span>
            <span className="ai-chat-widget-expense-list-date">
              {item.dateLabel}
            </span>
          </div>
          <span className="ai-chat-widget-expense-list-amount">
            {item.amount}
          </span>
          <span
            className={`ai-chat-widget-status-pill ai-chat-widget-status-pill--${item.status}`}>
            {item.statusLabel}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ExpenseListWidget;
